import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Restores a previously archived non-SCIM user in the caller's active
 * org via `frontend.user.restoreUser`. Symmetric counterpart to
 * useArchiveUserTRPC.
 */
export const useRestoreUserTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.user.restoreUser.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.user.users.queryKey(),
        });
      },
    }),
  });

  return {
    restoreUser: (userId: string) => mutation.mutateAsync({ userId }),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
